import { actionTypes } from './actions';

export const initialState = {
  voiceId: null,
  status: null,
  sampleLink: null,
};

const instantVoiceTrainingReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ADD_INSTANT_VOICE_TRAINING: {
      const { instantVoiceTraining } = action;
      return { ...state, instantVoiceTraining };
    }
    case actionTypes.CLEAR_INSTANT_VOICE_TRAINING: {
      return initialState;
    }

    default:
      return state;
  }
};

export default instantVoiceTrainingReducer;
